const PropertyInfoCard = ({ label, value, icon, className = "", iconOffset = true }) => {
  return (
    <div className={`card-property-info ${className}`}>
      {iconOffset ? <div className="mt-[2px]">{icon}</div> : icon}
      <div className="flex flex-col gap-1">
        <p className="body-xs">{label}</p>
        <p className="body-m">{value}</p>
      </div>
    </div>
  );
};

export default PropertyInfoCard;
